import React, { useEffect, useState } from "react";
import { imgBaseUrl } from "../../api/api";
import { formatToDate } from "../master/FormatToDateTime";
import "./StudentIdCard1.css";

export default function StudentIdCard1({ data, batch }) {
  const [setting, setSetting] = useState({});

  useEffect(() => {
    setSetting(JSON.parse(localStorage.getItem("setting") ?? {}));
  }, []);
  return (
    <>
      <style>
        {`
        .a4-page-horizontal::before{
            background-image: url(${imgBaseUrl + setting?.logo_img});  
        }
          `}
      </style>
      <div className="a4-page-horizontal-1 p-1">
        <div className="row justify-content-center g-1 overflow-hidden">
          <div className="col-12">
            <div className="d-flex align-items-center justify-content-center gap-1">
              <img
                src={imgBaseUrl + setting?.logo_img}
                style={{ width: "80px" }}
                alt=""
              />
              <div className="institute-details text-center">
                <h6 className="m-0 ri-20px">{setting?.name}</h6>
                <p className="m-0">
                  {setting?.village} {setting?.district} {setting?.state},{" "}
                  {setting?.pin_code}
                </p>
                <p className="m-0">
                  Contact : {setting?.mobile}
                  {setting?.secondary_mobile &&
                    `, ${setting?.secondary_mobile}`}{" "}
                </p>
                <p className="m-0">Email : {setting?.email}</p>
              </div>
            </div>
          </div>
          <div className="col-11 border-top"></div>
          <div className="col-12 ps-2 pe-3 m-0">
            <p className="admission-date m-0">
              Admission Date :{" "}
              {formatToDate(data?.student_info?.admission_date)}
            </p>

            <div className="row m-0 p-0 mb-2 g-0 align-items-center">
              <div className="col-9 mt-2">
                <div className="row text-nowra">
                  <div className="col-4 text-nowrap">Registration No</div>
                  <div className="col-1">:</div>
                  <div className="col-6 fw-bold p-0">
                    {data?.student_info?.registration_no}
                  </div>
                  <div className="col-4 text-nowrap">Name</div>
                  <div className="col-1">:</div>
                  <div className="col-6 fw-bold p-0">
                    {data?.student_info?.name}
                  </div>
                  <div className="col-4 text-nowrap">Father`s Name</div>
                  <div className="col-1">:</div>
                  <div className="col-6 fw-bold p-0">
                    {data?.student_info?.father_name}
                  </div>
                  <div className="col-4 text-nowrap">Mobile No</div>
                  <div className="col-1">:</div>
                  <div className="col-6 fw-bold p-0">
                    {data?.student_info?.phone}
                  </div>
                  <div className="col-4 text-nowrap">Course Name</div>
                  <div className="col-1">:</div>
                  <div className="col-6 fw-bold p-0">
                    {batch?.course?.title}
                  </div>
                  <div className="col-4 text-nowrap">Batch Name</div>
                  <div className="col-1">:</div>
                  <div className="col-6 fw-bold p-0">{batch?.title}</div>

                  <div className="col-4 text-nowrap">Hostel</div>
                  <div className="col-1">:</div>
                  <div className="col-6 fw-bold p-0">
                    {data?.student_info?.hostel_status}
                  </div>
                </div>
              </div>
              <div className="col-3 p-0">
                {data?.student_info?.profile_picture ? (
                  <img
                    src={imgBaseUrl + data?.student_info?.profile_picture}
                    className="w-100 border profile-img"
                    alt=""
                  />
                ) : (
                  <img
                    src="/files/user.png"
                    className="w-100 border profile-img"
                    alt=""
                  />
                )}
              </div>
              <div className="col-12">
                <div className="row">
                  <div className="col-3 text-nowrap">Address</div>
                  <div className="col-1 text-end">:</div>
                  <div className="col-5 address  p-0">
                    {data?.student_info?.village},{" "}
                    {data?.student_info?.district}, {data?.student_info?.state}{" "}
                    {data?.student_info?.zipcode}
                  </div>
                </div>
              </div>
              <div className="text-end signature">
                <img src={imgBaseUrl + setting?.signature} alt="" />
                <p className="m-0">Auth. Signature</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
